const log_show = 'data-show'
import maps from './map'
let showMap = new maps()
export default function(fn) {
  let node = document.querySelectorAll(`[${log_show}]`)
  for (let i = 0; i < node.length; i++) {
    let dom = node[i]
    if (showMap.get(dom)) continue
    showMap.set(dom, true)
    fn(dom.getAttribute(`${log_show}`), 'show')
  }
}
